import CheckmarkSvg from "src/components/svg/CheckMarkSvg";
import classNames from 'classnames';
import styles from './LabelledCheck.module.css';

//#region [Props]
type LabelledCheckProps = {
	className?: string;
	selected?: boolean;
	selectionCallback: (isSelected: boolean) => void;
	value: string | number;
	label?: string;
};
//#endregion

//#region [Component]
export default function LabelledCheck({ className, selected = false, selectionCallback, value, label }: LabelledCheckProps) {
    return <label className={className}>
        <input className={styles.SCheckInput} type="checkbox" checked={selected} onChange={() => selectionCallback(!selected)} value={value} />
        <span className={classNames(styles.SLabelSpan, { [styles.selected]: selected })}>
            {selected && <CheckmarkSvg className={styles.SCheckMarkSvg} />} {label ?? value}
        </span>
    </label>;
}
//#endregion

//#region [Styles]
//#endregion
